import { INotification } from './notification.model';

export interface INotificationAlerte extends INotification {
  idAlerte: string;
}

export class NotificationAlerte implements INotificationAlerte {
  constructor(
    public readonly idAlerte: string,
    public readonly title?: string,
    public readonly body?: string
  ) {}
}
